import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";



const WhatsAppButton = () => {
    const [showText, setShowText] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    
    const phoneNumber = "5493571626547"; // tu número con código de país sin "+"
    const defaultMessage = "Hola, te escribo desde la web de Gamaan y quisiera recibir información sobre sus servicios financieros."; 
    
    const encodedMessage = encodeURIComponent(defaultMessage);
    
    const href = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
  useEffect(() => {
    const timer1 = setTimeout(() => setShowText(true), 500); // Aparece después de 0.5s
    const timer2 = setTimeout(() => setShowText(false), 5000); // Se oculta suavemente a los 5s

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  // Mostrar texto si está en hover o en el tiempo inicial
  const shouldShowText = showText || isHovered;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-4 right-4 z-50 flex items-center px-3 py-2 rounded-full shadow-lg transition-all duration-500 ease-in-out`}
      style={{
        backgroundColor: "#00271f", // verde más oscuro
        color: "white",
        fontWeight: 500,
        fontSize: "16px",
        maxWidth: shouldShowText ? "200px" : "48px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={() => setIsHovered(true)}
      onTouchEnd={() => setIsHovered(false)}
    >
      <FaWhatsapp size={30} className="mr1" />
      <span
        className={`transition-all duration-700 ease-in-out whitespace-nowrap overflow-hidden ${
          shouldShowText ? "opacity-100 max-w-[200px] ml-1" : "opacity-0 max-w-0 ml-0"
        }`}
      >
        Contactanos
      </span>
    </a>
  );
};

export default WhatsAppButton;
